









































































import VueOptions from '@utils/VueOptions'
import Modal from '@components/Modal'
import BrandSelector from '@ui/AudienceSetWizard/components/BrandSelector'
import TreeSelector from '@ui/TreeSelector'

settings =
  name: 'FormFieldCatexSelect'

  vue:
    props: ['value', 'errors']

    components: {
      Modal,
      BrandSelector,
      TreeSelector,
    }

    data: ->
      catex: @value
      catexModal:
        show: false
        mode: 'create'
        categories: []
        sponsor: null

    computed:
      catexTableData: ->
        Object.values(@catex).filter((c) => !c.prohibited).map((category) =>
          id: category.domain
          data: category
          category: category.category
          sponsors: category.sponsors
        )

      brandInitialValue: ->
        @catexModal.categories

      brandCategoriesOptions: ->
        mapping = @marketplace?.brand?.categories || {}
        tree = @marketplace?.brand?.category_tree || {}
        tree.other ||= "Other" # auto add as a top level category
        @jsonToElementUICascader tree, mapping

      brandCategoriesActions: ->
        select: @selectBrandCategory

      canSave: ->
        @catexModal.categories?.length and @catexModal.sponsor?

    methods:
      hiAddCategory: ->
        @catexModal =
          show: true
          mode: 'create'
          categories: []
          sponsor: null

      hiEditCategory: (category) ->
        @catexModal =
          show: true
          mode: 'edit'
          categories: [category]
          sponsor: null

      hiRemoveCatex: (catex) ->
        { category } = catex
        catex = JSON.parse(JSON.stringify(@catex))
        delete catex[category]
        @catex = catex
        @inputChanged()

      hiSaveCatexModal: ->
        { categories, sponsor } = @catexModal
        catex = JSON.parse(JSON.stringify(@catex))
        category = categories.pop()
        sponsors = catex[category]?.sponsors
        if sponsors?.length
          sponsors.push sponsor unless sponsors.some((c) => c.category is category)
        else
          catex[category] = { category, prohibited: false, sponsors: [sponsor] }
        @catex = catex
        @inputChanged()
        @closeSponsorModal()

      hiCloseCatexModal: ->
        @closeSponsorModal()

      inputChanged: ->
        @$emit 'input', @catex
        @$emit 'change', @catex

      selectBrandCategory: (categories) ->
        @catexModal.categories = categories

      closeSponsorModal: ->
        @catexModal.show = false

export default VueOptions.vue settings
